import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Visibility from "./Visibility"

const StyledDiv = styled.div`
  width: 100%
`

const Filters = ({onVisibilityChange, className, view}) => {
  return (
    <StyledDiv className={className}>
      <Visibility onChange={onVisibilityChange} initialValue={view} />
    </StyledDiv>
  )
}

Filters.propTypes = {
  className: PropTypes.string,
  onVisibilityChange: PropTypes.func.isRequired,
  view: PropTypes.string
}

Filters.defaultProps = {
  className: null,
  view: ""
}

export default Filters
